// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const entryClient = createTypedClient();
export const createEntryClient = (config) => createTypedClient(config);
